var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),(!_vm.loading)?_c('GlobalOffersScraperDataTable',{attrs:{"tableHeight":'600px',"rows_data":_vm.globalOffers}}):_vm._e(),(_vm.loading)?_c('div',[_vm._v("Loading ...")]):_vm._e()],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('h1',[_vm._v("Global Offers Scraper")])])
}]

export { render, staticRenderFns }